import { useQuery } from '@tanstack/react-query';
import {
    getPortfolioModalProjectDataQueryKey,
    getPortfolioModalSellerDataQueryKey,
    getPortfolioWidgetFullDataQueryKey,
} from '../server';
import {
    getPortfolioModalProjectDataClient,
    getPortfolioModalSellerDataClient,
    getPortfolioWidgetFullDataClient,
} from '../services';
import { Role } from '../components/PortfolioWidget/PortfolioWidgetContext';
import { ProjectSourceFilter, PortfolioAttachmentTransformation } from '../gql-operations/gql-generated';

export type PortfolioWidgetFullDataQueryUrlBuilder = (options: {
    username: string;
    roleIds?: string[];
    roles?: Role[];
    projectSource?: ProjectSourceFilter;
    limit?: number;
}) => string;

export const usePortfolioWidgetFullDataQuery = ({
    username,
    roleIds,
    roles,
    projectSource,
    urlBuilder,
    limit,
}: {
    username: string;
    roleIds?: string[];
    roles?: Role[];
    projectSource?: ProjectSourceFilter;
    urlBuilder: PortfolioWidgetFullDataQueryUrlBuilder;
    limit?: number;
}) =>
    useQuery({
        queryKey: getPortfolioWidgetFullDataQueryKey({ username, roleIds, roles, limit }),
        queryFn: () => getPortfolioWidgetFullDataClient(urlBuilder({ username, roleIds, roles, projectSource, limit })),
    });

export type PortfolioModalProjectDataQueryUrlBuilder = (options: {
    username: string;
    projectId: string;
    cardTransformation?: PortfolioAttachmentTransformation;
}) => string;

export const usePortfolioModalProjectDataQuery = ({
    username,
    projectId,
    cardTransformation,
    urlBuilder,
    keepPreviousData,
}: {
    username: string;
    projectId?: string;
    cardTransformation?: PortfolioAttachmentTransformation;
    keepPreviousData?: boolean;
    urlBuilder: PortfolioModalProjectDataQueryUrlBuilder;
}) =>
    useQuery({
        queryKey: getPortfolioModalProjectDataQueryKey({ username, projectId, cardTransformation }),
        enabled: !!projectId,
        keepPreviousData,
        queryFn: () =>
            getPortfolioModalProjectDataClient(
                urlBuilder({ username, projectId: projectId as string, cardTransformation })
            ),
    });

export type usePortfolioModalSellerDataQueryUrlBuilder = (options: { username: string }) => string;

export const usePortfolioModalSellerDataQuery = ({
    username,
    enabled,
    urlBuilder,
}: {
    username: string;
    enabled?: boolean;
    urlBuilder: usePortfolioModalSellerDataQueryUrlBuilder;
}) =>
    useQuery({
        queryKey: getPortfolioModalSellerDataQueryKey(username),
        queryFn: () => getPortfolioModalSellerDataClient(urlBuilder({ username })),
        enabled,
    });
